import { forwardRef } from 'react';
import { Tooltip } from 'components/ui/Tooltip';
import type { IconButtonProps } from './IconButton.props';
import { StyledIconButton } from './IconButton.styles';

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(({
  tooltipLabel,
  variant = 'default',
  visualSize = 'default',
  ...props
}, ref) => {
  const button = (
    <StyledIconButton
      ref={ref}
      iconButtonVariant={variant}
      visualSize={visualSize}
      {...props}
    />
  );

  if (!tooltipLabel) {
    return button;
  }

  return (
    <Tooltip title={tooltipLabel}>
      <span style={{ display: 'inline-flex' }}>{button}</span>
    </Tooltip>
  );
});

IconButton.displayName = 'IconButton';

export default IconButton;
